<template lang="pug">
v-main
  v-container(fluid)
    v-flex
      v-card
        v-toolbar.elevation-0(color="white")
          v-toolbar-title(v-model="title") {{ title }}
          v-spacer
          v-btn(dark, color="blue-secondary", to="/users/create" class="elevation-0") CREATE
        v-divider
        v-toolbar.elevation-0.mt-2.mb-4(color="white")
          v-select.hidden-sm-and-down.col-4.pl-0(
            label="Status",
            v-model="status",
            :items="dataStatus",
            hide-details
          )
          span.pr-2
          v-text-field.hidden-sm-and-down.col-8(
            flat,
            append-icon="search",
            placeholder="Keyword (optional)",
            v-model="keyword",
            hide-details
          )
        v-divider
        v-card-text.pa-0
          v-data-table(
            :headers="dataHeaders",
            :items="dataItems",
            :search="keyword"
          )
            template(v-slot:item.data-table-expand="{ headers, item }")
              v-icon.mr-4.blue-dark(title="detail", @click="onDetail(item.id)")
                | visibility
              v-icon.mr-2(
                title="edit",
                color="green",
                @click="onEdit(item.id)"
              )
                | edit

            template(v-slot:no-data)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.

            template(v-slot:no-results)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "UserList",
  components: {},
  props: {
    title: String,
  },
  data() {
    return {
      keyword: "",
      dataStatus: ["All", "Active", "Non Active"],
      group: ["All", "Admin", "User"],
      business_unit: [],
      dataHeaders: [
        { text: "Name", value: "full_name" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "msisdn" },
        { text: "Status", value: "is_active", filter: this.statusFilter },
        { text: "Actions", value: "data-table-expand" },
      ],
      dataItems: [],
      isSuperAdmin: false,
      users: [],
      status: "",
    };
  },
  mounted() {
    this.isSuperAdmin = this.$store.state.dataUsers.role;
    this.getDataUsers(this.isSuperAdmin);
  },
  methods: {
    getDataUsers: function (isSuperAdmin) {
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API + `/users/credentials`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          res.data.data.forEach((data) => {
            if (data.is_active == true) {
              data.is_active = "Active";
            } else {
              data.is_active = "Non Active";
            }
          });
          this.dataItems = res.data.data;
        })
        .catch((err) => {
          this.$toaster.error(err, { icon: "error" });
        })
        .finally(() => (this.loading = false));
    },
    onEdit(item) {
      this.$router.push({
        name: "Users Edit",
        params: { id: item },
      });
    },
    onDetail(item) {
      this.$router.push({
        name: "Users Detail",
        params: { id: item },
      });
    },
    statusFilter(val) {
      if (this.status == "All") {
        return true;
      }

      if (!this.status) {
        return true;
      }
      return val === this.status;
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
